import React from "react";
import { Box } from "@mui/material";

// The shared page-width wrapper - max-width and padding here must stay in
// sync with the nav bar and footer (see Navbar.tsx / footer/style.ts),
// which intentionally duplicate these exact breakpoint values so the three
// align pixel-for-pixel.
const Container = ({ children }: { children: React.ReactNode }) => (
  <Box
    sx={{
      maxWidth: 1200,
      mx: "auto",
      px: { xs: "32px", sm: "48px", md: "64px" },
      py: { xs: "24px", md: "32px" },
    }}
  >
    {children}
  </Box>
);

export default Container;
